/* ═══════════════════════════════════════════════
   KITSUNE MERCHANT — Variant Selection System
   ═══════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {

  // ── GRAB PRODUCT JSON ──
  const productJson = document.getElementById('product-json');
  if (!productJson) return;

  const product = JSON.parse(productJson.textContent);
  const variants = product.variants;

  // ── STATE ──
  let selectedOptions = {};
  let currentVariant = variants[0];

  // ── INIT: set first option buttons as selected ──
  product.options.forEach((option, i) => {
    const firstBtn = document.querySelector(`[data-option="${i + 1}"]`);
    if (firstBtn) {
      firstBtn.classList.add('selected');
      selectedOptions[i + 1] = firstBtn.dataset.value;
    }
  });

  // ── OPTION BUTTON CLICK ──
  document.querySelectorAll('.option-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const optionPos = parseInt(this.dataset.option);
      const value = this.dataset.value;

      // Deselect siblings
      document.querySelectorAll(`[data-option="${optionPos}"]`).forEach(b => b.classList.remove('selected'));
      this.classList.add('selected');

      // Update selected options
      selectedOptions[optionPos] = value;

      // Find matching variant
      updateVariant();
    });
  });

  function updateVariant() {
    // Find variant that matches all selected options
    const matched = variants.find(v => {
      return Object.entries(selectedOptions).every(([pos, val]) => {
        return v[`option${pos}`] === val;
      });
    });

    if (matched) {
      currentVariant = matched;
      updateUI(matched);
    } else {
      // Try to find closest available variant
      const available = variants.find(v => v.available);
      if (available) {
        currentVariant = available;
        updateUI(available);
      }
    }
  }

  function updateUI(variant) {
    // ── UPDATE PRICE ──
    const priceEl = document.getElementById('variant-price');
    const compareEl = document.getElementById('variant-compare-price');
    const saveBadge = document.getElementById('variant-save-badge');

    if (priceEl) {
      priceEl.textContent = formatMoney(variant.price);
    }

    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = 'inline';
        if (saveBadge) {
          const saving = variant.compare_at_price - variant.price;
          saveBadge.textContent = 'Save ' + formatMoney(saving);
          saveBadge.style.display = 'inline';
        }
      } else {
        compareEl.style.display = 'none';
        if (saveBadge) saveBadge.style.display = 'none';
      }
    }

    // ── UPDATE HIDDEN VARIANT INPUT ──
    const variantInput = document.getElementById('selected-variant');
    if (variantInput) variantInput.value = variant.id;

    // ── UPDATE IMAGE if variant has one ──
    if (variant.featured_image) {
      const mainImg = document.getElementById('main-product-img');
      if (mainImg) {
        mainImg.src = variant.featured_image.src;
      }
    }

    // ── UPDATE ADD TO CART BUTTON ──
    const atcBtn = document.getElementById('add-to-cart-btn');
    if (atcBtn) {
      if (variant.available) {
        atcBtn.disabled = false;
        atcBtn.textContent = 'Add to Cart 🛒';
        atcBtn.style.opacity = '1';
      } else {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Sold Out';
        atcBtn.style.opacity = '0.6';
      }
    }

    // ── UPDATE URL without reload ──
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  // ── FORMAT MONEY ──
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  // ── QUANTITY ADJUST ──
  window.adjustQty = function (delta) {
    const input = document.getElementById('qty');
    if (!input) return;
    input.value = Math.max(1, parseInt(input.value || 1) + delta);
  };

  // ── AJAX ADD TO CART ──
  const atcForm = document.getElementById('product-form');
  if (atcForm) {
    atcForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = document.getElementById('add-to-cart-btn');
      const qty = parseInt(document.getElementById('qty').value || 1);

      btn.textContent = 'Adding…';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: currentVariant.id, quantity: qty })
      })
        .then(r => r.json())
        .then(() => {
          btn.textContent = '✓ Added!';
          btn.style.background = 'linear-gradient(135deg,#1a5c1a,#0d3a0d)';
          updateCartCount();
          setTimeout(() => {
            btn.textContent = 'Add to Cart 🛒';
            btn.style.background = '';
            btn.disabled = false;
          }, 2000);
        })
        .catch(() => {
          btn.textContent = 'Add to Cart 🛒';
          btn.disabled = false;
        });
    });
  }

  // ── UPDATE CART BADGE ──
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const badge = document.getElementById('cart-count');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.style.transform = 'scale(1.4)';
          badge.style.background = '#F2C94C';
          setTimeout(() => {
            badge.style.transform = 'scale(1)';
            badge.style.background = '#D4A017';
          }, 300);
        }
      });
  }

  // ── CHECK URL FOR PRESELECTED VARIANT ──
  const urlParams = new URLSearchParams(window.location.search);
  const preselectedId = parseInt(urlParams.get('variant'));
  if (preselectedId) {
    const preselected = variants.find(v => v.id === preselectedId);
    if (preselected) {
      currentVariant = preselected;
      // Select the right buttons
      product.options.forEach((option, i) => {
        const val = preselected[`option${i + 1}`];
        document.querySelectorAll(`[data-option="${i + 1}"]`).forEach(btn => {
          btn.classList.toggle('selected', btn.dataset.value === val);
        });
        selectedOptions[i + 1] = val;
      });
      updateUI(preselected);
    }
  }
});
